module.exports = __webpack_public_path__ + "static/Pt06-756e4f4bd3f40fca7e491413f1a2b7dd.jpg";